export const loading = (value) => (
  <div className="animated fadeIn pt-3 text-center">
    {value ? value : "loading"}...
  </div>
);
